import { render, staticRenderFns } from "./eventoemitir.vue?vue&type=template&id=4f4f95b7"
import script from "./eventoemitir.vue?vue&type=script&lang=js"
export * from "./eventoemitir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports